import React, { useEffect, useRef } from 'react';
import './ConfirmDialog.css';

// Small modal confirm used for destructive / lossy actions (e.g. leaving an
// unsaved form, spec 3.2). `actions` render right-to-left in the footer; give the
// safe/primary action `tone: 'primary'` and the destructive one `tone: 'danger'`.
export default function ConfirmDialog({ title, message, actions = [], onDismiss }) {
  const ref = useRef(null);
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    const prev = document.activeElement;
    ref.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') { e.preventDefault(); onDismissRef.current?.(); } };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      if (prev && typeof prev.focus === 'function') prev.focus();
    };
  }, []);

  return (
    <div className="cd-backdrop" onMouseDown={onDismiss}>
      <div
        ref={ref}
        className="cd-modal"
        role="alertdialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="cd-icon"><i className="fi fi-rr-triangle-warning" /></div>
        <h2 className="cd-title">{title}</h2>
        {message && <p className="cd-message">{message}</p>}
        <div className="cd-actions">
          {actions.map((a) => (
            <button
              key={a.label}
              type="button"
              className={`cd-btn cd-btn-${a.tone || 'ghost'}`}
              onClick={a.onClick}
              disabled={a.disabled}
            >
              {a.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
